
$(() => {
  $('.feature-ribbon-quote').each(function () {
    const quoteribbon = $(this);
    if ($(this).css('background-color')) {
      if ($(window).width() > 667) {
        if (quoteribbon.attr('data-mobile-src') === '' && quoteribbon.attr('data-desktop-src') === '' && quoteribbon.attr('data-theme') === '') {
          quoteribbon.removeAttr('style');
        } else if (((quoteribbon.attr('data-mobile-src') === '' && quoteribbon.attr('data-desktop-src') === '') ||
         (quoteribbon.attr('data-mobile-src') !== '' && quoteribbon.attr('data-desktop-src') === ''))
                  && (quoteribbon.attr('data-theme'))) {
          quoteribbon.css('background-color', quoteribbon.attr('data-theme'));
        } else {
          quoteribbon.css('background-image', 'url(' + quoteribbon.attr('data-desktop-src') + ')');
        }
      } else {
        const imgSrc = quoteribbon.attr('data-mobile-src') || quoteribbon.attr('data-desktop-src');
        if (quoteribbon.attr('data-mobile-src') === '' && quoteribbon.attr('data-desktop-src') === '' && quoteribbon.attr('data-theme') === '') {
          quoteribbon.removeAttr('style');
        }
        if (quoteribbon.attr('data-mobile-src') === '' && quoteribbon.attr('data-desktop-src') === '') {
          quoteribbon.css('background-color', quoteribbon.attr('data-theme'));
        } else {
          quoteribbon.css('background-image', 'url(' + imgSrc + ')');
        }
      }
    }
  });
});
